import React, { Component } from 'react'
import styled from 'styled-components'

import SearchField from '../../lib/components/SearchField'
import NativeDropdown from '../../lib/components/NativeDropdown'
// import DatePicker from '../../lib/components/DatePicker'

import {
  PROJECT_TYPE_DROPDOWN,
  PROJECT_STATUS_DROPDOWN,
} from '../../pages/project-profit-sheet/constants'

const lob = [{ label: 'Select LOB', value: '' }]

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  > div {
    margin-left: 10px;
  }
`

class SubmitMenu extends Component {
  /**
   * @param {React.KeyboardEvent<HTMLInputElement>} e
   */
  handleSearchFieldChange = e => {
    if (e.key === 'Enter') {
      this.props.handleSearch(e.target.value)
    }
  }

  render = () => {
    const { props } = this
    return (
      <React.Fragment>
        <Wrapper>
          <NativeDropdown
            placeholder="Select Type"
            options={ PROJECT_TYPE_DROPDOWN }
            onChange={ e => props.handleDropdown('type', e) }
            value={ props.type }
          />
          <NativeDropdown
            placeholder="Select LOB"
            options={
              props.lobs
                ? [...lob, ...props.lobs.map(lob => ({ label: lob.name, value: lob.name }))]
                : lob
            }
            onChange={ e => props.handleDropdown('lob', e) }
            value={ props.lob }
          />
          <NativeDropdown
            placeholder="Select Status"
            options={ PROJECT_STATUS_DROPDOWN }
            onChange={ e => props.handleDropdown('status', e) }
            value={ props.status }
          />
          {/* <DatePicker
          placeholderText='Start Date'
          dateFormat='DD/MM/YYYY'
          onChange={ (e) => props.handleDropdown('start_date', e) }
          selected={ props.start_date }
        />
        <DatePicker
          placeholderText='End Date'
          dateFormat='DD/MM/YYYY'
          onChange={ (e) => props.handleDropdown('end_date', e) }
          selected={ props.end_date }
        /> */}
          <SearchField
            placeholder="Search by name ..."
            onKeyPress={ this.handleSearchFieldChange }
            defaultValue={ props.search }
          />
        </Wrapper>
      </React.Fragment>
    )
  }
}

export default SubmitMenu



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/ProjectListMenu.jsx